(function () {
    'use strict';

    angular
        .module('oddCampaignModule')
        .controller('oddCampaignQuestionnaireListEditController', Controller);

    Controller.$inject = ['$scope', 'notificationService', 'oddCampaignService'];

    function Controller($scope, notificationService, oddCampaignService) {
        var boxModelClone = angular.copy($scope.boxModel);
        var campaign = $scope.boxContext.campaign;

        $scope.remove = remove;
        $scope.moveTo = moveTo;

        $scope.ctrlCtxt = {};
        $scope.sortableOptions = {
            animation: 0,
            forceFallback: true,
            scroll: true,
            scrollSpeed: 20,
            scrollSensitivity: 30,
            onUpdate: onSortUpdate,
            handle: '.sortable-handle'
        };

        function remove(item) {
            $scope.ctrlCtxt.isLoading = true;

            return oddCampaignService.deleteQuestionnaire(campaign.ODDBusinessUnitID, campaign.ODDExternalPartyID,
                    campaign.ODDCampaignID, item.ODDCampaignQuestionnaireID).then(function () {

                notificationService.notify('Questionnaire has been deleted');

                _.pull($scope.boxModel, item);
            }).finally(function () {
                $scope.ctrlCtxt.isLoading = false;
            });
        }

        function moveTo(item, direction) {
            _.pull($scope.boxModel, item);

            if (direction === 'top') {
                $scope.boxModel.unshift(item);
            } else {
                $scope.boxModel.push(item);
            }

            onSortUpdate();
        }

        function onSortUpdate() {
            $scope.ctrlCtxt.isLoading = true;

            return oddCampaignService.orderQuestionnaires(campaign.ODDBusinessUnitID, campaign.ODDExternalPartyID,
                    campaign.ODDCampaignID, $scope.boxModel).then(function() {

                notificationService.notify('Questionnaires have been reordered');
                boxModelClone = angular.copy($scope.boxModel);
            }).catch(function() {
                $scope.boxModel = angular.copy(boxModelClone);
            }).finally(function () {
                $scope.ctrlCtxt.isLoading = false;
            });
        }
    }

})();